import * as React from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import './styles/Co2EmissionLabel.scss';

type Props = {
  value: number;
  large?: boolean;
  withIcon?: boolean;
  textLeft?: boolean;
  isTotal?: boolean;
};

export const Co2EmissionLabel: React.FC<Props> = ({
  value,
  withIcon = true,
  large = false,
  textLeft = false,
  isTotal = false,
}) => {
  const { t } = useTranslation();

  if (value >= 0) {
    return (
      <span
        className={classNames('co2-emission', {
          'co2-emission--large': large,
          'co2-emission--align-left': textLeft,
        })}>
        {withIcon && <i className="material-symbols">eco</i>}
        <strong>
          {isTotal && `${t('co2Emission.total.label')}: `}
          {t('co2Emission.label', { value })}
        </strong>
      </span>
    );
  }
};
